export const MonitoringStatuses = {
    HISTORIC: 'Historic',
    REAL_TIME: 'RealTime',
    REAL_TIME_FORCED: 'RealTimeIncompatible',
    DISABLING_MONITORING: 'DisablingMonitoring',
    ENABLING_MONITORING: 'EnablingMonitoring',
    UNKNOWN: 'Unknown'
}
